<mat-checkbox
  class="ai-consent-checkbox"
  [checked]="checked()"
  [disabled]="disabled()"
  (change)="changed.emit($event.checked)"
  [attr.data-testid]="testId()"
>
  I am authorised to give this consent for {{ businessName() || 'the business' }}.
  {{ businessName() || 'The business' }} consents to CapX using AI-assisted assessment for its
  funding applications. The information and documents submitted for the business, by the business
  itself or by an agent for it, and CapX's notes of what the business has told it, are sent to
  the AI providers CapX uses, which may be outside South Africa. CapX will ensure that any AI
  provider it uses complies with the Protection of Personal Information Act (POPIA). The providers
  check the documents and produce an advisory assessment for the CapX team. A person at CapX always makes the final
  decision. This consent covers every application made for the business until it is withdrawn,
  which can be done at any time on CapX Flow or by contacting CapX. See the
  <a routerLink="/legal/privacy" target="_blank" rel="noopener">Privacy Policy</a> for how personal
  information is handled.
</mat-checkbox>
